// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3F8np","content":"Card_content__2u8qS","button":"Card_button__1P8HC","contenedor":"Card_contenedor__2boL2","titleLink":"Card_titleLink__1ej9g"};